/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraVariazioneCapiCreateDTO
 */
export interface ChiusuraVariazioneCapiCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraVariazioneCapiCreateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraVariazioneCapiCreateDTO
     */
    capi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraVariazioneCapiCreateDTO
     */
    peso?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraVariazioneCapiCreateDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the ChiusuraVariazioneCapiCreateDTO interface.
 */
export function instanceOfChiusuraVariazioneCapiCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraVariazioneCapiCreateDTOFromJSON(json: any): ChiusuraVariazioneCapiCreateDTO {
    return ChiusuraVariazioneCapiCreateDTOFromJSONTyped(json, false);
}

export function ChiusuraVariazioneCapiCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraVariazioneCapiCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'capi': !exists(json, 'capi') ? undefined : json['capi'],
        'peso': !exists(json, 'peso') ? undefined : json['peso'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function ChiusuraVariazioneCapiCreateDTOToJSON(value?: ChiusuraVariazioneCapiCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoAnimale': value.idTipoAnimale,
        'capi': value.capi,
        'peso': value.peso,
        'note': value.note,
    };
}

